import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import { fetchDistributorDashboardData } from "../../../redux/slice/DistributorDashboardSlice";
import CardWithChart from "./Charts/CardWithChart";
import CardWithChartComp from "./Charts/CardWithChartComp";
import TopPerformers from "./Charts/TopPerformers";
import ShareQRCode from "./Charts/ShareQRCode";
import { fetchDistributorQRData } from "../../../redux/slice/DistributorQrSlice";
import CardWithLineChart from "../../../components/CardWithLineChart";
import StackedBarChart from "../../../components/StackedBarChart";
import IncidentDetails from "../../../components/IncidentDetails";

function DistributorDashboard() {
  const dispatch = useDispatch();
  const { DistributorQRData } = useSelector((state) => state.DISTRIBUTORQR);
  const { DistributorDashboardData } = useSelector(
    (state) => state.DISTRUBUTORDASHBOARD
  );
  // Logged-in distributor identity, used to build the end-user invitation link.
  const { user_id, userData } = useSelector((state) => state.AUTH);

  // Frontend-generated invitation link the distributor can share. The app reads
  // distributorId and resolves the supplier via GET /admin/get_distributor_by_id;
  // distributor_email is included as a fallback for older links/app builds.
  const inviteLink = `${window.location.origin}/invite?distributorId=${
    user_id || ""
  }&distributor_email=${encodeURIComponent(userData?.email || "")}`;

  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchDistributorDashboardData());
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setDataFetched(true);
      }
    };
    dispatch(fetchDistributorQRData());
    fetchData();
  }, [dispatch]);

  if (!dataFetched) {
    return <Loader />;
  }

  return (
    <div className="row row-gap-4">
      <div className="col-md-6 col-xl-4">
        <CardWithChart title={"Registered Users"} />
      </div>
      <div className="col-md-6 col-xl-4">
        <CardWithChartComp title={"Registered Clients"} />
      </div>
      <div className="col-sm-12 col-xl-4">
        <ShareQRCode
          title="Share QR Code"
          url={DistributorQRData}
          inviteLink={inviteLink}
        />
      </div>
      <div className="col-xl-7 col-xxl-8">
        <CardWithLineChart
          style={{ fontSize: 20, fontWeight: 500 }}
          className={"text_gray"}
        />
      </div>
      <div className="col-xl-5 col-xxl-4">
        <IncidentDetails />
      </div>
      <div className="col-xl-5 col-xxl-4">
        <TopPerformers title="Top Performers by Quotes" />
      </div>
      <div className="col-xl-7 col-xxl-8">
        <StackedBarChart
          colors={["#FF6666", "#CCA300", "#359742"]}
          data={DistributorDashboardData?.data?.incident_data}
        />
      </div>
    </div>
  );
}
export default DistributorDashboard;
